import Toast from './Toast.vue';

export default {
  install(Vue) {
    Vue.component('GlobalToast', Toast);
    Vue.mixin({
      methods: {
        showToast(msg) {
          this.$root.$emit('show-toast', { msg });
        },
        hideToast() {
          this.$root.$emit('hide-toast');
        },
      },
    });
  },
};
